// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Page} from '../../comp/page';
import {Routed_tabs} from '../../comp/tabs';
import {Downloads} from '../../comp/downloads';
import {Offers} from './tabs/offers.js';
import {Referees} from './tabs/referees.js';
import {Transactions} from './tabs/transactions.js';
import {Promo} from './tabs/promo.js';
import {Income} from './tabs/income.js';
import {get_path} from './util.js';
import {Head} from './head/head.js';
import * as cns from './me.module.less';

const TABS = [{
    to: get_path('/earnings'),
    label: 'Earnings',
    component: Offers,
}, {
    to: get_path('/referrals'),
    label: 'Referrals',
    component: Referees,
}, {
    to: get_path('/passive-income'),
    label: 'Passive Income',
    component: Income,
}, {
    to: get_path('/promo'),
    label: 'Promotions',
    component: Promo,
}, {
    to: get_path('/transactions'),
    label: 'Transactions',
    component: Transactions,
}];

export function Me(){
    return <Page className={cns.root}>
      <Head/>
      <Routed_tabs items={TABS} size="m"/>
      <Switch>
        {TABS.map(item=><Route key={item.to} path={item.to}
          component={item.component}/>)}
        <Redirect to={TABS[0].to}/>
      </Switch>
      <Downloads/>
    </Page>;
}
